import { useState } from 'react';

import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import { StatefulButton } from '@edx/paragon';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { EnvelopeSVG } from '../../assets/svgs';
import ArrowButton from '../../common-components/ArrowButton';
import EmailRetryIssueNotice from '../../common-components/EmailRetryIssueNotice';
import {
  LOGIN_PAGE, MAXIMUM_FAILED_ATTEMPS_RESEND_EMAIL, PASSWORD_RESET_CODE_ENTRY,
} from '../../data/constants';
import { updatePathWithQueryParams } from '../../data/utils';
import { setRedirectTarget } from '../../common-components/data/actions';

import messages from '../messages';

const ForgotPasswordEmailSent = ({
  email,
  submitState,
  handleSubmit,
}) => {
  const [failedAttemps, setFailedAttemps] = useState(0);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    dispatch(setRedirectTarget(LOGIN_PAGE));
    navigate(updatePathWithQueryParams(LOGIN_PAGE));
  };

  const handleFailedAttempts = () => {
    handleSubmit();
    setFailedAttemps(prev => prev + 1);
  };

  return (
    <> 
      <div className="flex-center-column all-the-forget-password-email-sent-new"> 
        <div className="flex-center-column flex-fill">
          <h1 className="page-title my-3"><FormattedMessage {...messages['forgot.password.email.sent.page.title']} values={{ enter: <br /> }} /></h1>
          <div className="flex-center-column">
            <img src={EnvelopeSVG} alt="envelope-svg" />
            <p className="regular-text text-center mb-0">{formatMessage(messages[failedAttemps === 0 ? 'forgot.password.email.sent.page.subtitle' : 'forgot.password.email.sent.page.additional.email.sent'], { email: <span style={{ fontWeight: 'bold' }}>{email}</span>, enter: <br /> })}</p>
            {failedAttemps < MAXIMUM_FAILED_ATTEMPS_RESEND_EMAIL ? (
              <p className="regular-text mt-2 mb-0">
                {formatMessage(messages['forgot.password.email.sent.page.didnt.got.text'])} - <button type="button" className="link-style" onClick={handleFailedAttempts}>{formatMessage(messages['forgot.password.email.sent.page.resend.email'])}</button>
              </p>
            ) : (
              <EmailRetryIssueNotice />
            )}

          </div>
        </div>
        <div className='page-button-forget'>
          <StatefulButton
            id="submit-forget-password"
            name="submit-forget-password"
            type="submit"
            className="logistration-btn"
            labels={{
              default: formatMessage(messages['forgot.password.email.sent.page.button']),
              pending: '',
            }}
            state={submitState}
            // PT 5.8, recommendation #1: the forgot-password response no longer
            // carries a token/link (see verify_forgot_password_code.overrides in
            // edx-extensions) - this used to parse one out of `resetLink` here.
            // The OTP-entry page now identifies its session by the email already
            // in Redux state (set by ForgotPasswordPage on submit) instead.
            onClick={() => navigate(PASSWORD_RESET_CODE_ENTRY)}
          />
          <ArrowButton className="page-button-forget-single-back" text={formatMessage(messages['back.to.sign.in'])} onClick={handleBackToLogin} />
        </div>
      </div>
      </>
  );
};

ForgotPasswordEmailSent.propTypes = {
  email: PropTypes.string.isRequired,
  submitState: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordEmailSent;
